import axios from "axios";

export const apiGetCall = async (url, config={}) => {
  try {
    const response = await axios.get(url, config);    
    return response.data;
  } catch (error) {
    throw error.response?.data;
  }
};

export const apiPostCall = async (url, data, config={}) => {
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const apiPostCallWithFullError = async (url, data, config={}) => {
  try {
    const response = await axios.post(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiPutCallWithFullError = async (url, data, config={}) => {
  try {
    const response = await axios.put(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiPatchCall = async (url, data, config={}) => {
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const apiPutCall = async (url, data, config={}) => {
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const apiDeleteCall = async (url, data, config={}) => {
  try {
    const response = await axios.delete(url, data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
